import React, { FC } from 'react';

import { Select } from 'chakra-react-select';
import { FormControl, FormLabel, Text } from '@chakra-ui/react';

import { useSites } from 'hooks/sites/useSites';
import { useFormikContext } from 'formik';

import { SiteMultiSelectProps } from './SiteMultiSelect.props';

const FETCH_ALL_SITES = true;

const SiteMultiSelectView: FC<SiteMultiSelectProps> = ({ values }) => {
  const { data, isLoading } = useSites(FETCH_ALL_SITES);

  const {
    errors,
    touched,
    setFieldValue,
    setFieldTouched,
  } = useFormikContext<any>();

  const sites = data || [];

  const options = sites.map((p) => ({ label: p.name, value: p._id }));

  const _values = values
    ? sites
        ?.filter((p) => values?.includes(p._id))
        ?.map((p) => ({ label: p.name, value: p._id }))
    : undefined;

  const error = errors?.sites;
  const touch = touched?.sites;

  return (
    <FormControl mt={8}>
      <FormLabel
        htmlFor="sites"
        textTransform="capitalize"
        fontSize="12px"
        color="#afafaf">
        Sites
      </FormLabel>
      <Select
        isMulti
        value={_values}
        isDisabled={isLoading}
        isLoading={isLoading}
        options={options}
        tagVariant="solid"
        colorScheme="primary"
        closeMenuOnSelect={false}
        onBlur={() => setFieldTouched('sites', true)}
        chakraStyles={{
          dropdownIndicator: (_props) => ({
            ..._props,
            bg: 'transparent',
          }),
          option: (_props) => ({
            ..._props,
            padding: '10px',
            borderBottom: '1px solid #ccc',
          }),
          menuList: (_props) => ({
            ..._props,
            padding: '0px',
            marginBottom: '20px',
          }),
        }}
        onChange={(newValue) => {
          const _sites = newValue.map((n) => n.value);

          setFieldValue('sites', _sites);
        }}
      />
      {error && touch && (
        <Text fontSize="xs" color="red.500">
          {error || ''}
        </Text>
      )}
    </FormControl>
  );
};

export default SiteMultiSelectView;
